var map = {
	"./basecomponent.js": "./cartridges/app_project/cartridge/client/default/js/es6-components/basecomponent.js",
	"./checkout-gtm.js": "./cartridges/app_project/cartridge/client/default/js/es6-components/checkout-gtm.js",
	"./form-newsletter-remote.js": "./cartridges/app_project/cartridge/client/default/js/es6-components/form-newsletter-remote.js",
	"./form-remote.js": "./cartridges/app_project/cartridge/client/default/js/es6-components/form-remote.js",
	"./form-validation.js": "./cartridges/app_project/cartridge/client/default/js/es6-components/form-validation.js",
	"./format-date.js": "./cartridges/app_project/cartridge/client/default/js/es6-components/format-date.js",
	"./gift-message.js": "./cartridges/app_project/cartridge/client/default/js/es6-components/gift-message.js",
	"./gtm.js": "./cartridges/app_project/cartridge/client/default/js/es6-components/gtm.js",
	"./json_da.js": "./cartridges/app_project/cartridge/client/default/js/es6-components/json_da.js",
	"./modal-handler.js": "./cartridges/app_project/cartridge/client/default/js/es6-components/modal-handler.js",
	"./watcher.js": "./cartridges/app_project/cartridge/client/default/js/es6-components/watcher.js"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./cartridges/app_project/cartridge/client/default/js/es6-components lazy recursive ^\\.\\/.*\\.js$";
module.exports = webpackAsyncContext;